import { Outlet } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "./AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
//import Sidebar from "../components/SidebarLiveBkp.jsx";
import logo from "../images/Logo.png";
import logos from "../images/Logos.png";

import ThemeSettings from "../theme/ThemeSettings.jsx";

import Sidebar from "../components/Sidebar.jsx";
import CarbonBar from "./CarbonBar.jsx";

function Layout() {
  const [collapsed, setCollapsed] = useState(false);

  const { token, logout } = useAuth();
  const username = localStorage.getItem("username");
  //const roleName = localStorage.getItem("roleName");
  //const counterId = localStorage.getItem("counterId");
  const id = localStorage.getItem("id");
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();

    localStorage.clear();

    navigate("/");
  };

  if (!token || location.pathname === "/") {
    return null;
  }

  return (
    <>
     <CarbonBar />
      <div className="app-layout">
        <div
          className="app-sidebar"
          style={{ width: collapsed ? "70px" : "250px", transition: "0.4s" }}
          hidden={id === "2"}
        >
          <div className="app-logo">
              {collapsed ? (
                <img src={logos} alt="Logo" width={35} height={35} />
              ) : (
                <img src={logo} alt="Logo" width="100%" height="auto" />
              )}
          </div>

          <div className="p-1">
            <Sidebar />
            {Number(id) === 6 && <ThemeSettings />}
          </div>
        </div>

        {/* Main Content */}

        <div className="app-content">
          <div hidden={id === "2"}>
            <div className="app-header d-flex justify-content-between align-items-center px-4 py-3 shadow-sm">
              <div className="d-flex align-items-center gap-3">
                <button
                  className="btn btn-outline-info"
                  onClick={() => setCollapsed(!collapsed)}
                >
                 <i class="bi bi-list-columns-reverse"></i>
                </button>
              </div>

              <div className="d-flex align-items-center gap-3">
                <span className="text">
                  <b>Welcome, {username}</b>
                </span>

                <button className="btn btn-danger" onClick={handleLogout}>
                  <i className="bi bi-box-arrow-right"> Logout</i>
                </button>
              </div>
            </div>
          </div>

          <div
            className={Number(id) === 2 ? "hide" : "container-fluid app-body"}
          >
            <div className={Number(id) === 2 ? "hide" : "py-4 px-2"}>
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Layout;
